import React from 'react';
import { Empty, List, Tag, Typography } from 'antd';
import type { WorklogSummary, WorklogTaskType } from '../../types/worklog';
import { WORKLOG_TASK_TYPE_LABELS } from '../../types/worklog';

// Tag 配色：只为了让类型一眼可分，没有语义含义。
const TAG_COLORS: Record<WorklogTaskType, string> = {
  fix: 'red',
  feature: 'blue',
  refactor: 'purple',
  docs: 'green',
  config: 'orange',
  analysis: 'cyan',
  chore: 'magenta',
  other: 'default',
};

type Props = {
  worklogs: WorklogSummary[];
  onOpen: (worklog: WorklogSummary) => void;
};

// 后端给的是 UTC ISO 串，这里按本地时区渲染 —— 人看的是自己的时间。
function formatCompletedAt(value: string): string {
  const date = new Date(value);
  return date.toLocaleString('zh-CN', { hour12: false });
}

const WorklogList: React.FC<Props> = ({ worklogs, onOpen }) => {
  if (worklogs.length === 0) {
    return <Empty description="没有符合条件的日志" />;
  }

  return (
    <List
      dataSource={worklogs}
      rowKey={(worklog) => worklog.id}
      renderItem={(worklog) => (
        <List.Item
          className="cursor-pointer hover:bg-gray-50"
          onClick={() => onOpen(worklog)}
        >
          <List.Item.Meta
            title={
              <div className="flex items-center gap-2">
                <Tag color={TAG_COLORS[worklog.task_type] ?? 'default'}>
                  {WORKLOG_TASK_TYPE_LABELS[worklog.task_type] ?? worklog.task_type}
                </Tag>
                <span className="font-medium">{worklog.title}</span>
              </div>
            }
            description={
              <div className="flex flex-col gap-1">
                <span>{worklog.summary}</span>
                <Typography.Text type="secondary" className="text-xs">
                  {formatCompletedAt(worklog.completed_at)}
                  {worklog.working_directory ? ` · ${worklog.working_directory}` : ''}
                  {/* 0 不显示 —— 现存九百多条里绝大多数没有关联，每行都挂一个
                      「任务 0」等于在整份列表上重复一句废话。 */}
                  {worklog.task_links_count > 0 ? ` · 任务 ${worklog.task_links_count}` : ''}
                </Typography.Text>
              </div>
            }
          />
        </List.Item>
      )}
    />
  );
};

export default WorklogList;
